import { z } from 'zod';

/**
 * Webapp login schema. Mirrors the hand-rolled validators previously
 * in src/app/router/actions/helpers.ts:
 *   - email: required + RFC-ish regex
 *   - password: required + 6-char min (login keeps the legacy 6-char
 *     floor; the stronger 8+uppercase+digit+special rule applies on
 *     register / reset)
 *   - remember: hidden field; "1" or "0"
 */
export const loginSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Please enter a valid email address'),
  password: z
    .string()
    .min(1, 'Password is required')
    .min(6, 'Password must be at least 6 characters'),
  remember: z.string().optional(),
});

export type LoginInput = z.infer<typeof loginSchema>;
